import React from 'react';
import { GestureResponderEvent, StyleSheet, View, ViewStyle } from 'react-native';
import { ActivityIndicator, Text, Touchable } from '..';
import { Content } from './Content';
import { BaseFrame, ToggleFrameButton } from '.';

/*eslint-disable react-native/no-unused-styles*/
const getStyles = (): Record<string, Record<string, string | number>> =>
  StyleSheet.create({
    headerFrame: {
      borderBottomWidth: 1,
      borderBottomColor: '#cccccc',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingBottom: 5,
    },
    titleOnlyFrame: {
      justifyContent: 'flex-start',
    },
    loader: {
      height: 100,
    },
  });

interface FrameProps {
  title?: string;
  isLoadingForToggling?: boolean;
  toggleTitle?: string;
  onToggleFolded?: (event: GestureResponderEvent) => void;
  isLoading?: boolean;
  children?: React.ReactNode;
  headerTouchableOnly?: boolean;
  style?: ViewStyle;
  titleContainerStyle?: ViewStyle;
}

export const Frame = ({
  title,
  isLoadingForToggling,
  toggleTitle,
  onToggleFolded,
  isLoading = false,
  children = null,
  headerTouchableOnly = false,
  style,
  titleContainerStyle,
}: FrameProps): React.JSX.Element=> {
  const styles = getStyles();
  const content = isLoading ? <ActivityIndicator style={styles.loader} /> : children;
  const toggleContent = onToggleFolded ? <ToggleFrameButton title={toggleTitle} /> : null;

  return (
    <BaseFrame onFrameTouched={headerTouchableOnly ? undefined : onToggleFolded} style={style}>
      {title && (
        <Touchable onPress={onToggleFolded} underlayColor="white">
          <View style={[styles.headerFrame, !onToggleFolded && styles.titleOnlyFrame, titleContainerStyle]}>
            <Text>{title}</Text>
            {isLoadingForToggling ? <ActivityIndicator /> : toggleContent}
          </View>
        </Touchable>
      )}
      {content}
    </BaseFrame>
  );
};
